module.exports = __webpack_public_path__ + "img/star-add.62dd8ee8.svg";